import styled from "styled-components";

export const ViewNISParticipantHeaderWrapper = styled.div`
  .header-container {
    display: flex;
    justify-content: space-between;
  }
  .button-container {
    display: flex;
    align-items: center;
    gap: 16px;
  }
`;
